module.exports = __webpack_public_path__ + "img/mtx_electricity_meter_x_xxxx.e1ab1fea.png";